import palette from '@lib/core/src/theme/palette';
import { Avatar, TextFieldProps, CircularProgress } from '@mui/material';

import { AccountUserDto } from '@/api/generated';
import ExpandUpDownIcon from '@/assets/buttons-icons/expand-up-down.svg?react';

import {
  SmallAvatars,
  InputAndAvatarsContainer,
  TextInputSelect,
  ExpandUpDownContainer,
  LoadingContainer
} from './InputAndAvatarsStyles';

interface InputAndAvatarsProps {
  smallAvatarsWidth?: number;
  smallAvatars?: AccountUserDto[];
  setOpen: () => void;
  placeholder: string;
  params: TextFieldProps;
  isInputValid: boolean;
  isInputInList: boolean;
  selectedUsers?: AccountUserDto[];
  isLoading?: boolean;
}

const InputAndAvatars = ({
  smallAvatarsWidth = 0,
  smallAvatars = [],
  setOpen,
  placeholder,
  params,
  isInputValid,
  isInputInList,
  selectedUsers = [],
  isLoading = false
}: InputAndAvatarsProps) => {
  const validAvatars = smallAvatars.filter(Boolean);

  return (
    <InputAndAvatarsContainer>
      <SmallAvatars width={`${smallAvatarsWidth}px`} onClick={setOpen}>
        {validAvatars.map((user, index) => (
          <Avatar
            key={user.id ?? index}
            sx={{
              position: 'absolute',
              left: `${index * 15}px`,
              top: '50%',
              transform: 'translate(0, -50%)',
              zIndex: index,
              fontSize: '12px',
              width: '20px',
              height: '20px',
              backgroundColor: user.photoUrl ? palette.white : palette.grey[200],
              border: `1px solid ${palette.white}`,
              color: palette.grey[500]
            }}
            src={user.photoUrl}
          >
            {user.photoUrl ? null : (user.firstName?.[0] ?? user.email?.[0] ?? '').toUpperCase()}
          </Avatar>
        ))}

        {selectedUsers.length > 4 && (
          <Avatar
            sx={{
              position: 'absolute',
              left: `${validAvatars.length * 15}px`,
              top: '50%',
              transform: 'translate(0, -50%)',
              zIndex: validAvatars.length,
              fontSize: '12px',
              width: '20px',
              height: '20px',
              backgroundColor: palette.grey[200],
              border: `1px solid ${palette.white}`,
              color: palette.grey[500]
            }}
          >
            +
          </Avatar>
        )}
      </SmallAvatars>

      <TextInputSelect
        {...params}
        isvalid={isInputValid || isInputInList}
        marginleft={`${smallAvatarsWidth + 10}px`}
        placeholder={placeholder}
      />

      {isLoading && (
        <LoadingContainer>
          <CircularProgress size={20} />
        </LoadingContainer>
      )}

      <ExpandUpDownContainer onClick={setOpen}>
        <ExpandUpDownIcon />
      </ExpandUpDownContainer>
    </InputAndAvatarsContainer>
  );
};

export default InputAndAvatars;
